import BannerPlan from "components/BannerPlan";
import CouponInputAuth from "components/CouponInputAuth";
import React, { useCallback, useEffect, useState } from "react";
import { checkCoupon } from "services/coupon";
import { listPlan } from "services/plan";
import { Plan } from "types/plan";
import { getPlansWithDiscounts } from "utils/getPlansWithDiscount";

type Props = {
  entityCoupon?: string;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setIdSelected: React.Dispatch<React.SetStateAction<string>>;
  idSelected: string;
  setCouponCode: React.Dispatch<React.SetStateAction<string>>;
  couponCode: string;
  errors: any;
};

const ChooseYourPlan: React.FC<Props> = ({
  entityCoupon,
  setLoading,
  setIdSelected,
  idSelected,
  couponCode,
  setCouponCode,
  errors,
}): JSX.Element => {
  const [plans, setPlans] = useState<Plan[]>([]);
  const [originalValueMonth, setOriginalValueMonth] = useState<number>(0);
  const [originalValueOneTime, setOriginalValueOneTime] = useState<number>(0);
  const [couponData, setCouponData] = useState<any>();
  const [isValidCoupon, setIsValidCoupon] = useState<boolean>(false);

  const getPlansList = useCallback(async () => {
    try {
      setLoading(true);

      let plansWithDiscount = [];
      const { data } = await listPlan();
      if (data.Plans.length > 0) {
        plansWithDiscount = data.Plans.filter(
          (plan: any) =>
            plan.active === true && plan.id !== "price_1PvH7gBYagSIczaot9LJtvaP"
        );
      }

      plansWithDiscount = await getPlansWithDiscounts({
        coupon: entityCoupon,
        currentPlans: plansWithDiscount,
      });

      plansWithDiscount.forEach((plan: Plan) => {
        if (plan.type === "one_time") {
          setOriginalValueOneTime(plan.unit_amount);
        }
        if (plan.type === "recurring") {
          setOriginalValueMonth(plan.unit_amount);
        }
      });

      setPlans(plansWithDiscount);
    } catch (_) {
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getPlansList();
  }, [getPlansList]);

  const validCoupon = async (sendCoupon: string) => {
    try {
      setLoading(true);
      if (couponData?.id === sendCoupon) {
        return;
      }

      const { data: dataCoupon } = await checkCoupon(sendCoupon);

      const plansWithDiscount = await getPlansWithDiscounts({
        coupon: sendCoupon,
        currentPlans: plans,
        originalValueMonth,
        originalValueOneTime,
      });

      setPlans(plansWithDiscount);
      setCouponData(dataCoupon);
      setIsValidCoupon(true);
    } catch (_) {
      await getPlansList();
      setCouponCode("");
      setCouponData("COUPON NOT VALID!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="flex flex-row justify-center items-center mt-8">
        <div className="font-nunito font-normal text-sm text-bt-gray-700">
          CHOOSE YOUR PLAN
        </div>
      </div>
      <div className="flex flex-row justify-center items-center mt-8">
        {plans.map((p: any) => {
          return (
            <div className="flex flex-col mx-4" key={p.id}>
              <BannerPlan
                selected={idSelected === p.id}
                onClick={() => setIdSelected(p.id)}
                title={p.type}
                value={p.unit_amount}
              />
            </div>
          );
        })}
      </div>
      {errors?.idSelected && (
        <div className="flex flex-row justify-center items-center mt-8">
          <span className="font-nunito mt-1 text-base text-bt-red">
            {errors?.idSelected}
          </span>
        </div>
      )}

      <div className="flex flex-col items-center justify-center my-6">
        <div className="flex flex-col w-full ml-2">
          <CouponInputAuth
            placeholder={"Coupon code"}
            label="Coupon code"
            value={couponCode}
            onChange={(e: any) => setCouponCode(e.target.value)}
            onBlur={() => validCoupon(couponCode)}
          />
        </div>
        <div className="flex flex-col w-full my-auto">
          <span
            className="text-base font-sora mt-5 ml-4"
            style={{
              fontStyle: "normal",
              fontWeight: 400,
              color: isValidCoupon ? "#408E5A" : "#FD5B28",
            }}
          >
            {couponData && (isValidCoupon ? couponData.name : couponData)}
          </span>
        </div>
      </div>
    </>
  );
};

export default ChooseYourPlan;
